import React from 'react';
import { Link } from 'react-router-dom';
export function HomeNavFreeTrial() {
  return <Link to="/free-trial" className="bg-[#00D4FF] text-black px-6 py-2.5 rounded font-bold uppercase tracking-wider text-sm hover:bg-[#33ddff] transition-colors shadow-[0_0_15px_rgba(0,212,255,0.3)] hover:shadow-[0_0_25px_rgba(0,212,255,0.5)]" data-id="element-1168">
      Free Trial
    </Link>;
}